import { TOKEN_KEY, EXPIRE, USERNAME_KEY, USEREMAIL_KEY, PW2, MENUS_KEY } from '../configs';
import CryptoJS from 'crypto-js';
import Cookies from 'universal-cookie';


class Auth {

  isAuthenticated = () => {
    const tokenValue = localStorage.getItem(TOKEN_KEY);
    if (!tokenValue) {
      return false;
    }
    const expire = tokenValue.match(/\.(\d+)$/)[1];
    return parseInt(expire, 10) > Date.now();
  }


  login({ token, name, menus, email }, expireTime) {
    const expire = expireTime ? expireTime : Date.now() + EXPIRE;
    const cookies = new Cookies();
    localStorage.setItem(TOKEN_KEY, token + '.' + expire);
    localStorage.setItem(USERNAME_KEY, name);
    localStorage.setItem(USEREMAIL_KEY, email);
    localStorage.setItem(MENUS_KEY, JSON.stringify(menus));
    cookies.set(TOKEN_KEY, token, { path: '/' });

    this.fetchUserPermissions();
  }

  async fetchUserPermissions() {
    try {
      const { default: userPermissionsService } = await import('./userPermissionsService');
      await userPermissionsService.getCurrentUserPermissions();
    } catch (error) {
      console.error('Erro ao buscar permissões após login:', error);
    }
  }

  logout() {
    const cookies = new Cookies();
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USERNAME_KEY);
    localStorage.removeItem(MENUS_KEY);
    localStorage.removeItem(USEREMAIL_KEY);
    
    this.clearPermissionsCache();
    
    cookies.remove(TOKEN_KEY, { path: '/' })

  }

  getToken() {
    const tokenValue = localStorage.getItem(TOKEN_KEY);
    return (tokenValue || '').replace(/\.\d+$/, '');
  }

  getUsername() {
    return localStorage.getItem(USERNAME_KEY);
  }

  getUserEmail() {
    return localStorage.getItem(USEREMAIL_KEY);
  }

  getMenus() {
    return JSON.parse(localStorage.getItem(MENUS_KEY));
  }

  async clearPermissionsCache() {
    try {
      const { default: userPermissionsService } = await import('./userPermissionsService');
      userPermissionsService.clearPermissions();
    } catch (error) {
      console.error('Erro ao limpar cache de permissões:', error);
    }
  }

  // user from privacy tools
  decryptFromPrivacy(encodeToken) {
    try {
      // The decodeURIComponent() function decodes a URI component.
      const token = decodeURIComponent(encodeToken);
      const bytes = CryptoJS.AES.decrypt(token, PW2);
      const plaintext = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(plaintext);
    } catch (error) {
      console.error('Error decrypt', error);
      return '';
    }
  }

}

const authStorage = new Auth();
export default authStorage;